import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const resetDeviceApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/reset-device`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
